import React from 'react';
import { useLocation } from 'react-router-dom';

import Tabs, { Tab } from '../../library/tabs/tabs';
import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';

import { useMessage } from '../../shared/hooks/hooks';

import { getTabURLParams } from '../../shared/utils/url-params/url-params';

import { CheckFitResult } from '../../shared/constants/fit';
import { WIPER_SETS_TAB_MSG } from '../../shared/constants/messages';
import { SetSearchTypes } from '../../shared/constants/set-products';

import './set-product-tabs.scss';

interface SetProductTabsProps {
  doesFitEnum: CheckFitResult;
  productSetSearchType: string;
}

function SetProductTabs(props: SetProductTabsProps) {
  const { doesFitEnum, productSetSearchType } = props;
  const { pathname, search } = useLocation();
  const messages = useMessage([WIPER_SETS_TAB_MSG]);

  if (doesFitEnum !== CheckFitResult.FIT || !productSetSearchType) {
    return null;
  }

  const tooltipContent =
    messages?.WIPER_SETS_TAB_MSG ||
    'A wiper blade set includes driver and passenger side blades. We recommend replacing both for the best performance.';

  const basePath = pathname.replace(
    `/${productSetSearchType.toLowerCase()}`,
    ''
  );
  const urlParams = getTabURLParams(search);

  return (
    <div styleName="container">
      <hr styleName="divider" />
      <Tabs>
        <Tab
          href={`${basePath}/set${urlParams}`}
          isSelected={productSetSearchType === SetSearchTypes.SET}
          styleName="tab-container"
        >
          <Typography styleName="sets-label" weight="heavy">
            Sets <Tooltip content={tooltipContent} styleName="sets-tooltip" />
          </Typography>
        </Tab>
        <Tab
          href={`${basePath}/driver${urlParams}`}
          isSelected={productSetSearchType === SetSearchTypes.DRIVER}
          styleName="tab-container"
        >
          <Typography weight="heavy">Driver</Typography>
        </Tab>
        <Tab
          href={`${basePath}/passenger${urlParams}`}
          isSelected={productSetSearchType === SetSearchTypes.PASSENGER}
          styleName="tab-container"
        >
          <Typography weight="heavy">Passenger</Typography>
        </Tab>
      </Tabs>
    </div>
  );
}

export default SetProductTabs;
